const NAMESPACE = "forgotPassword";

const KEYS = {
    header: "header",
    instructionText: "instructionText",
    emailInputLabel: "emailInputLabel",
    sendResetLinkBtnLabel: "sendResetLinkBtnLabel",
    emailPlaceholder: "emailPlaceholder",
    emailRequiredValidationMessage: "emailRequiredValidationMessage",
    successAlertTitle: "successAlertTitle",
    successAlertText: "successAlertText"
};

const MESSAGES = {
    [KEYS.header]: {
        value: "Forgot your Password?",
        comment:
            "Header for the page that allows users who forgot their password to request an email that will allow them to reset it."
    },
    [KEYS.instructionText]: {
        value: "Please enter your email address and submit to have a password reset link sent to you.",
        comment:
            "Instruction text that tells a user to enter the email address of their account in order to have an email sent to them that will allow them to reset their password"
    },
    [KEYS.emailInputLabel]: {
        value: "Email Address:",
        comment: "Label for the input where the user will enter their email address"
    },
    [KEYS.sendResetLinkBtnLabel]: {
        value: "Send Reset Link",
        comment:
            "Label for the button that submits the user's request to receive an email with a link to reset their password"
    },
    [KEYS.emailPlaceholder]: {
        value: "example{'@'}company.com",
        comment: "Email placeholder in the email address input demonstrating the format of a valid email address"
    },
    [KEYS.emailRequiredValidationMessage]: {
        value: "Please enter your PowerClerk email address.",
        comment:
            "Validation message informing the user that they must enter their PowerClerk email address in order to receive a password reset email"
    },
    [KEYS.successAlertTitle]: {
        value: "Request received",
        comment:
            "Title of an alert that displays when a user's request for a password reset email has been successfully received"
    },
    [KEYS.successAlertText]: {
        value: "If the specified email address belongs to a registered PowerClerk user, a reset message has been sent to that email address.",
        comment:
            "Text of the success alert that informs the user that the request for a reset email has been received, and if the email address is valid, a reset email will be sent to that address"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
